import React, { useState } from "react";
import style from "./index.module.scss";
import { Button, Input } from "antd";

interface ToolsProps {
    onSearch: (val: string) => void; //查询
    length?: number; //数据数量
}

export default function Tools({ onSearch, length }: ToolsProps) {
    const [text, setText] = useState("");

    return (
        <div className={style.root}>
            <div className={style.container}>
                <div className={style.count}>邀请记录（{length || 0}）</div>
                <div>
                    <Input
                        placeholder="请输入要搜索学生的姓名或学号"
                        className={style.input}
                        onChange={e => setText(e.target.value)}
                        onPressEnter={() => onSearch(text)}
                    />
                    <Button
                        type="primary"
                        className={style.search}
                        onClick={() => onSearch(text)}>
                        查询
                    </Button>
                </div>
            </div>
        </div>
    );
}
